"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CommunityContentType = {
  Unknown: 0,
  FeedContent: 1,
  UserHighlight: 2,
  TeamHighlight: 3,
  PerformanceCenter: 4,
  Message: 5,
  HudlHighlight: 6
};

exports.default = CommunityContentType;